import * as yup from "yup";

export const accountDeletionStep1Schema = yup.object({
  email: yup
    .string()
    .required("Обязательное поле")
    .email("Неверный формат email"),
});

export type UpdateUserFormValues = yup.InferType<
  typeof accountDeletionStep1Schema
>;

//TODO перед выходом в прод вернуть 10мин
export const RESEND_TIMEOUT = 60 * 1000;
